import React from 'react';
import { TableComponent, connect } from "../tableComponent";
import moment from 'moment';

class Component extends TableComponent {

  apiPath = "affiliate/sales_last"

  makeColumns = () => {
    let isAgent = this.props.user.role_id == 0;
    let earnings = this.props.user.chatsales_earnings;
    const columns = [
      {
        Header: "Date",
        accessor: "timenow",
        minWidth: 130,
        sortable: false,
        // resizable: false,
        className: "text-center",
        Cell: props => <div class="text-center">{moment(props.value*1000).format("D MMM YYYY, HH:mm:ss")}</div>
      }, {
        Header: "$",
        accessor: "total_dollars",
        sortable: false,
        // resizable: false,
        minWidth: 30,
        className: "text-center",
        Cell: props => <div class="text-center">${isAgent ? earnings : props.value}</div>
        
      }
    ] 
    if (!isAgent) {
      columns.splice(1,0,{
        Header: "Subaffiliate",
        id: "subaffiliate",
        accessor: "subaffiliate",
        sortable: false,
        // resizable: false,
        className: "text-center",
        Cell: props => <div>{props.value}</div>
        // minWidth: 50,
        // Cell: props => <div class="text-center">${isAgent ? earnings : props.value}</div>        
      })
    }  
    return columns; 
  }

  tableParams = {
    manual: true,
    defaultPageSize: 5
  }

  render() {
    let isAgent = this.props.user.role_id == 0;
    let earnings = this.props.user.chatsales_earnings;    
    return (
      <div>            
        <div class="box p-3">
          <div class="d-flex">
            <span class="text-muted">Total Sales</span>
          </div>
          <div class="py-3 text-center text-lg text-success">
            ${isAgent ? (this.props.total.total_sales || 0)*earnings : (this.props.total.total_dollars || 0)}
          </div>
          <div class="d-flex">
            <span class="flex text-muted">Previous 30 days:</span>
            <span><i class="fa fa-caret-up text-success"></i> 
              ${isAgent? (this.props.total.month_sales || 0)*earnings : (this.props.total.month_dollars || 0)}
            </span>
          </div>
        </div>
        
        <div class="box">
          <div class="box-content last-sales">
            {this.reactTable()}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(Component,"affiliate_sales_last")